import { render } from "./FormText.vue?vue&type=template&id=80ed05fa"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__